<template>
<div class="container home-wrap">
  <div class="display_flex relative">
    <img src="./images/banner.png" class="home-banner" />
    <div class="home-input-group">
      <h2 class="home-luck-draw-title">填写以下信息可以参与戴尔公司的抽奖活动</h2>
      <div class="flex_row flex_aCenter home-luck-draw-info">
        <img src="./images/gift.png" class="home-luck-draw-gift" />
        <div>抽奖奖品：飞利浦肩颈按摩器</div>
      </div>
      <div class="input-container">
        <div class="input-item"
             v-for="(item,index) in inputData"
             :key="index"
        >
          <div class="input-label input-label-must">{{item.label}}</div>
          <div class="input-target">
            <div v-if="item.component==='radio'" class="flex_row flex_aCenter container">
              <div class="display_flex_1 flex_row"
                v-for="(cItem,cIndex) in item.data"
                :key="'radio-'+cIndex"
              >
                <div class="flex_row flex_aCenter"
                  @click="item.value = cItem.value"
                >
                  <img src="./images/radio-active.png" v-if="item.value === cItem.value" class="input-radio-icon" />
                  <img src="./images/radio.png" v-else class="input-radio-icon" />
                  <span class="input-label">{{cItem.label}}</span>
                </div>
              </div>
            </div>
            <div v-else class="container flex_row flex_aCenter">
              <div class="display_flex_1">
                <input
                    :placeholder="item.placeholder"
                    v-model="item.value"
                    :type="mobile ? (item.type ||'text'):'text'"
                />
              </div>
              <div v-if="item.code"
                   @click="startTime(item)"
                   :class="{
                     'input-code-text-disabled':  exportData.disabled
                   }"
                   class="button-active input-label input-code-text">{{exportData.text}}</div>
            </div>

          </div>
        </div>
        <div class="home-input-introduce">
          本次活动由戴尔科技赞助支持。有关戴尔科技集团如何处理您的个人数据的详情，请参阅我们的隐私声明
          <a href="http://www.dell.com/learn/cn/zh/cncorp1/policies-privacy">http://www.dell.com/learn/cn/zh/cncorp1/policies-privacy</a>
        </div>
        <div class="flex_row">
          <div class="flex_row flex_aCenter"
               @click="readStatus = !readStatus"
          >
            <img src="./images/radio-active.png" v-if="readStatus" class="input-radio-icon" />
            <img src="./images/radio.png" v-else class="input-radio-icon" />
            <span class="home-input-introduce" style="padding: 0">我已阅读并同意戴尔隐私声明</span>
          </div>
        </div>
        <div class="home-input-margin-wrap">
          <template
              v-for="(item,index) in footerInput"
              :key="index"
          >
            <div class="input-item"
                 v-if="item.draw !== false"
            >
              <div class="input-label">{{item.label}}</div>
              <div class="input-target"
                   :class="['input-target-'+item.component]"
              >
                <div v-if="item.component==='radio'" class="flex_row flex_aCenter container"
                     :class="{
                  'input-target-radio-between':item.data.length > 2
                }"
                >
                  <div class="display_flex_1 flex_row"
                       v-for="(cItem,cIndex) in item.data"
                       :key="'radio-'+cIndex"
                  >
                    <div class="flex_row flex_aCenter"
                         @click="item.value = cItem.value;item.change && item.change(item.value,index,item,footerInput)"
                    >
                      <img src="./images/radio-active.png" v-if="item.value === cItem.value" class="input-radio-icon" />
                      <img src="./images/radio.png" v-else class="input-radio-icon" />
                      <span class="input-label">{{cItem.label}}</span>
                    </div>
                  </div>
                </div>
                <div v-else class="container flex_row flex_aCenter">
                  <div class="display_flex_1">
                    <input
                        :placeholder="item.placeholder"
                        v-model="item.value"
                        :type="mobile ? (item.type ||'text'):'text'"
                    />
                  </div>
                  <div v-if="item.code"
                       @click="startTime(item)"
                       :class="{
                     'input-code-text-disabled':  exportData.disabled
                   }"
                       class="button-active input-label input-code-text">{{exportData.text}}</div>
                </div>

              </div>
            </div>
          </template>
        </div>
        <div
            @click="submit"
            class="button home-button relative button-active flex_row flex_center"
            :class="{
                'button-disabled':loading
              }"
        >
          <img src="./images/login.png" class="home-login-icon" />
          <span>登录</span>
        </div>
      </div>

    </div>

  </div>

</div>
</template>

<script>
import inputData,{footerInput} from './data/input';
import request, {openMessage} from '@/utils/request';
import storage from "@/utils/storage";
import codeMixins from '../../control/code';
import verification from '../../utils/verification/index';
import { message } from 'ant-design-vue';
export default {
  name: "home",
  data(){
    return {
      inputData:inputData(),
      footerInput:footerInput(),
      mobile:false,
      loading:false,
      visible:false,
      readStatus:false,
      tipContent:[]
    }
  },
  mixins:[codeMixins],
  methods:{
    watchMobile(config){
      this.mobile = config.realWidth <= 768
    },
    submit(){

      if (this.loading) return ;

      if (!this.readStatus) return openMessage('info','我已阅读并同意戴尔隐私声明');

      verification.verification({
        data: this.inputData,
        complete:(data)=>{
          this.loading=true;

          this.footerInput.map((item)=>{
            data.value[item.key] = item.value;
          });
          if (data.value.is_ok === undefined) {
            data.value.is_ok = 2;
          }
          if (data.value.is_ok !== 1) {
            data.value.type = 0;
          }

          request.$request({
            url:'index/lenovo/hit_login_20230224',
            data:data.value,
            method:'post'
          }).then((data)=>{
            if(data.code === 1) {
              storage.setItem(this.storageKey,data);
              this.responseData = data;
              this.openLogin();
            } else {
              return openMessage('info',data.msg);
            }
          }).finally(()=>{
            this.loading = false;
          })
        },
        cache(item){
          openMessage('info',item.tip)
        }
      })
    },
    openTip(content){
      this.visible = true;
      this.tipContent = content;
    },
    openLogin(){
      if(this.responseData) {
        return this.goLogin(this.responseData);
      }
      return false;
    },
    goLogin(data){
      if(data.data) {
        location.href = data.data;
        return true;
      }
      return false;
    },
    installWxConfig(){
      // let resultData = {};
      // request.$request({
      //
      // }).then((data)=>{
      //   wx.config({
      //     debug: true, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
      //     appId: '', // 必填，公众号的唯一标识
      //     timestamp: '', // 必填，生成签名的时间戳
      //     nonceStr: '', // 必填，生成签名的随机串
      //     signature: '',// 必填，签名
      //     jsApiList: [] // 必填，需要使用的 JS 接口列表
      //   });
      // })
      // wx.ready(function(){
      //   this.setWxShare(resultData);
      // })
    },
    setWxShare(data){
      wx.updateAppMessageShareData({
        title: data.title, // 分享标题
        desc: data.content, // 分享描述
        link: data.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
        imgUrl: data.image, // 分享图标
      });
      wx.updateTimelineShareData({
        title: data.title, // 分享标题
        link: data.link, // 分享链接
        imgUrl: data.image, // 分享图标
      })
    }
  },
  created() {

    this.storageKey = '20230215MultiCapital-1';

    message.config({
      top: `30px`,
      duration: 2,
      maxCount: 3,
    });

    try {
      this.responseData = storage.getItem(this.storageKey);
      if(!this.openLogin()) {
        this.installWxConfig();
      }

    } catch (e) {
      this.installWxConfig();
    }
    observer_size.push( (config)=>{
      this.watchMobile(config);
    });
    this.watchMobile(screen_conf);
  }
}
</script>

<style scoped src="./style.scss" lang="scss">

</style>
